__turbopack_context__.v({
  "bubbleNavigationWrapper": "xhCiyG_bubbleNavigationWrapper",
  "container": "xhCiyG_container",
});
